import AsyncStorage from '@react-native-community/async-storage';
import { Firebase, FirebaseRef } from '../lib/firebase';

export function toggleNewGameParamOld(param, uid) {
  console.log('toggleNewGameParam', param, uid);
  if (param && uid) {
    return dispatch => new Promise(resolve => resolve(dispatch({ type: 'TOGGLE_NEW_GAME_PARAM', data: param, uid })));
  }
  return () => new Promise(resolve => resolve());
}

export function toggleNewGameParam(param, uid) {
  console.log('toggleNewGameParam', param);

  if (uid && param) {
    const UID = (
      FirebaseRef
      && Firebase
      && Firebase.auth()
      && Firebase.auth().currentUser
      && Firebase.auth().currentUser.uid
    ) ? Firebase.auth().currentUser.uid : null;

    const promises = [];

    console.log('changeNotificationSettings', uid, UID, param);

    return (dispatch, getState) => new Promise(async (resolve) => {
      const { userSettings } = getState();


      if (param === 'parasta') {
        if (userSettings && userSettings[uid] && userSettings[uid][param]) {
          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/${param}`).set(false).then(() => {
            console.log('changeNotificationSettings update done', param, false);
          }));

          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/G`).set(true).then(() => {
            console.log('changeNotificationSettings update done', 'G', true);
          }));
        } else {
          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/${param}`).set(true).then(() => {
            console.log('changeNotificationSettings update done', param, true);
          }));

          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/G`).set(false).then(() => {
            console.log('changeNotificationSettings update done', 'G', false);
          }));
        }
      } else if (param === 'G') {
        if (userSettings && userSettings[uid] && userSettings[uid][param]) {
          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/${param}`).set(false).then(() => {
            console.log('changeNotificationSettings update done', param, false);
          }));

          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/parasta`).set(true).then(() => {
            console.log('changeNotificationSettings update done', 'parasta', true);
          }));
        } else {
          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/${param}`).set(true).then(() => {
            console.log('changeNotificationSettings update done', param, true);
          }));

          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/parasta`).set(false).then(() => {
            console.log('changeNotificationSettings update done', 'parasta', false);
          }));
        }
      } else if (param === 'atra' || param === 'pro' || param === 'maza' || param === 'fourPRoom' || param === 'privateRoom' || param === 'studentZole') {
        console.log('changeNotificationSettings usersSettings', param, UID);
        if (userSettings && userSettings[uid] && userSettings[uid][param]) {
          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/${param}`).set(false).then(() => {
            console.log('changeNotificationSettings update done', param, false);
          }));
        } else {
          promises.push(FirebaseRef.child(`usersSettings/${UID}/newGameSettings/${param}`).set(true).then(() => {
            console.log('changeNotificationSettings update done', param, true);
          }));
        }
      }

      dispatch({ type: 'TOGGLE_NEW_GAME_PARAM', data: param, uid });

      Promise.all(promises).then(() => resolve()).catch(err => resolve());

      // return resolve();
      // resolve(dispatch({ type: 'CHANGE_NOTIFICATION_SETINGS', param, uid }));
    });
  }
  return () => new Promise(resolve => resolve());
}


export function initializeFiltersFromBackup(params, uid) {
  // if (params && uid) {
  //   return dispatch => new Promise(resolve => resolve(dispatch({ type: 'INITIALIZE_BACKUP_PARAMS', data: params, uid })));
  // }
  return () => new Promise(resolve => resolve());
}

export function toggleFilterParam(value, uid) {
  console.log('toggleFilterParam', value, uid);
  if (uid) {
    return dispatch => new Promise(resolve => resolve(dispatch({
      type: 'TOGGLE_ROOMS_FILTER_PARAM', data: value, uid,
    })));
  }
  return () => new Promise(resolve => resolve());
}

export function resetFilterRoomsExit(uid) {
  if (uid) {
    const value = {
      speed: [],
      bet: [],
      minGames: [],
      fourPRoom: [],
      gameType: [],
      maza: false,
      privateRoom: false,
      pro: false,
    };
    return dispatch => new Promise(resolve => resolve(dispatch({
      type: 'TOGGLE_ROOMS_FILTER_PARAM', data: value, uid,
    })));
  }
  return () => new Promise(resolve => resolve());
}

export function setNewGameBet(bet, uid) {
  console.log('setNewGameBet', bet, uid);
  if (bet && uid) {
    return dispatch => new Promise(async (resolve) => {
      FirebaseRef.child(`usersSettings/${uid}/newGameSettings/bet`).set(bet).then(() => {

        return resolve(dispatch({ type: 'SET_NEW_GAME_BET', data: bet, uid }));
      });
    });
  }
  return () => new Promise(resolve => resolve());
}

export function setNewGameSpeed(speed, uid) {
  console.log('setNewGameSpeed', speed, uid);
  if (speed && uid) {
    return dispatch => new Promise(async (resolve) => {
      FirebaseRef.child(`usersSettings/${uid}/newGameSettings/speed`).set(speed).then(() => {

        return resolve(dispatch({ type: 'SET_NEW_GAME_SPEED', data: speed, uid }));
      });
    });
  }
  return () => new Promise(resolve => resolve());
}

export function setNewMinGamesFunc(minGames, uid) {
  console.log('setNewMinGamesFunc', minGames, uid);
  if (minGames && uid) {
    return dispatch => new Promise(async (resolve) => {
      FirebaseRef.child(`usersSettings/${uid}/newGameSettings/minGames`).set(minGames).then(() => {

        return resolve(dispatch({ type: 'SET_NEW_MIN_GAMES', data: minGames, uid }));
      });
    });
  }
  return () => new Promise(resolve => resolve());
}

export function toggleSound(uid) {
  if (uid) {
    return (dispatch, getState) => new Promise(async (resolve) => {
      const { userSettings } = getState();

      if (userSettings && userSettings[uid] && userSettings[uid].soundOn) {
        FirebaseRef.child(`usersSettings/${uid}/userSettings/soundOn`).set(false).then(() => {
          console.log('changeNotificationSettings update done', 'soundOn', false);

          return resolve(dispatch({ type: 'SET_SOUND', uid, data: false }));
        });
      } else {
        FirebaseRef.child(`usersSettings/${uid}/userSettings/soundOn`).set(true).then(() => {
          console.log('changeNotificationSettings update done', 'soundOn', true);

          return resolve(dispatch({ type: 'SET_SOUND', uid, data: true }));
        });
      }
    });
  }
  return () => new Promise(resolve => resolve());
}

export function setDefaultSettings(uid) {
  console.log('setDefaultSettings');
  if (uid) {
    return dispatch => new Promise(resolve =>
    //  dispatch({ type: 'SET_DEFAULT_GAME_SETTINGS', uid });
      resolve(dispatch({ type: 'SET_DEFAULT_SETTINGS', uid })));
  }
  return () => new Promise(resolve => resolve());
}


export function changeNotificationSettings(setting, uid) {
  if (setting === 'newDesign') {
    return () => new Promise(resolve => resolve());
  }

  if (uid && setting) {
    const UID = (
      FirebaseRef
      && Firebase
      && Firebase.auth()
      && Firebase.auth().currentUser
      && Firebase.auth().currentUser.uid
    ) ? Firebase.auth().currentUser.uid : null;

    console.log('changeNotificationSettings', uid, UID, setting);

    return (dispatch, getState) => new Promise(async (resolve) => {
      const { userSettings } = getState();


      if (userSettings && userSettings[uid] && userSettings[uid].notificationSettings && userSettings[uid].notificationSettings[setting]) {
        await FirebaseRef.child(`usersSettings/${UID}/notificationSettings/${setting}`).set(false).then(() => {
          console.log('changeNotificationSettings update done', setting, false);
        });
      } else {
        await FirebaseRef.child(`usersSettings/${UID}/notificationSettings/${setting}`).set(true).then(() => {
          console.log('changeNotificationSettings update done', setting, true);
        });
      }

      resolve(dispatch({ type: 'CHANGE_NOTIFICATION_SETINGS', setting, uid }));
    });
  }
  return () => new Promise(resolve => resolve());
}

export function changeGameSettingOld(setting, uid) {
  console.log('changeGameSetting', setting, uid);

  if (uid && setting) {
    return dispatch => new Promise(resolve => resolve(dispatch({ type: 'CHANGE_GAME_SETINGS', setting, uid })));
  }
  return () => new Promise(resolve => resolve());
}

export function changeGameSetting(setting, uid) {
  if (uid && setting) {
    const UID = (
      FirebaseRef
      && Firebase
      && Firebase.auth()
      && Firebase.auth().currentUser
      && Firebase.auth().currentUser.uid
    ) ? Firebase.auth().currentUser.uid : null;

    console.log('changeGameSetting', uid, UID, setting);

    return (dispatch, getState) => new Promise(async (resolve) => {
      const { userSettings } = getState();


      if (userSettings && userSettings[uid] && userSettings[uid].gameSettings && userSettings[uid].gameSettings[setting]) {
        await FirebaseRef.child(`usersSettings/${UID}/gameSettings/${setting}`).set(false).then(() => {
          console.log('changeGameSetting update done', setting, false);
        });
      } else {
        await FirebaseRef.child(`usersSettings/${UID}/gameSettings/${setting}`).set(true).then(() => {
          console.log('changeGameSetting update done', setting, true);
        });
      }

      resolve(dispatch({ type: 'CHANGE_GAME_SETINGS', setting, uid }));
    });
  }
  return () => new Promise(resolve => resolve());
}

export const getUsersSetting = () => {
  const UID =
    FirebaseRef &&
    Firebase &&
    Firebase.auth() &&
    Firebase.auth().currentUser &&
    Firebase.auth().currentUser.uid
      ? Firebase.auth().currentUser.uid
      : null;

  return (dispatch, getState) => {
    if (!UID) {
      const { userSettings } = getState();
      const defaults = userSettings?.default ?? {};


      const keys = [
        "G",
        "bet",
        "fourPRoom",
        "maza",
        "minGames",
        "parasta",
        "privateRoom",
        "pro",
        "speed",
        "studentZole",
      ];
      const newNewGameSettings = keys.reduce((acc, k) => {
        acc[k] = defaults[k];
        return acc;
      }, {});

      dispatch({
        type: "GET_ALL_NOTIFICATION_SETINGS",
        uid: null,
        settings: {
          leaveRoom: true,
          lastRound: true,
          quitRound: true,
          ignorePlayer: true,
          quitAccount: true,
          purchaseGift: true,
          removeGift: true,
          showAfterRound: true,
          showAtRoomEnd: true,
          settingsFetched: true
        },
      });

      dispatch({
        type: "GET_ALL_GAME_SETINGS",
        uid: null,
        settings: { doubleClickPlay: false },
      });

      dispatch({
        type: "GET_ALL_NEW_GAME_SETINGS",
        uid: null,
        settings: newNewGameSettings,
      });

      dispatch({ type: "SET_SOUND", uid: null, data: defaults?.userSettings?.soundOn ?? true });
      return Promise.resolve();
    }

    // Ir UID → velkam no Firebase
    return new Promise((resolve) =>
      FirebaseRef.child(`usersSettings/${UID}`).once("value", (snapshot) => {
        const remoteSettings = snapshot.val() ?? {};
        const remoteNewGameSettings = remoteSettings.newGameSettings ?? {};

        const { userSettings } = getState();
        const defaults = userSettings?.default ?? {};
        const user = userSettings?.[UID] ?? {};

        const localNotificationSettings = user?.notificationSettings ?? null;
        const localGameSettings = user?.gameSettings ?? null;
        const localSoundOn = user?.soundOn ?? null;

        const keys = [
          "G",
          "bet",
          "fourPRoom",
          "maza",
          "minGames",
          "parasta",
          "privateRoom",
          "pro",
          "speed",
          "studentZole",
        ];

        // remote → user[UID] → defaults (ļauj false/0 ar ??)
        const newNewGameSettings = keys.reduce((acc, key) => {
          acc[key] = remoteNewGameSettings[key] ?? user[key] ?? defaults[key];
          return acc;
        }, {});

        const newNotificationSettings =
          remoteSettings.notificationSettings ?? localNotificationSettings ?? {
            leaveRoom: true,
            lastRound: true,
            quitRound: true,
            ignorePlayer: true,
            quitAccount: true,
            purchaseGift: true,
            removeGift: true,
            showAfterRound: true,
            showAtRoomEnd: true,
          };

        const newGameSettings =
          remoteSettings.gameSettings ?? localGameSettings ?? {
            doubleClickPlay: false,
          };

        const newSoundOnSetting =
          remoteSettings.userSettings?.soundOn ?? localSoundOn ?? true;

        dispatch({
          type: "GET_ALL_NOTIFICATION_SETINGS",
          uid: UID,
          settings: newNotificationSettings,
        });


        dispatch({
          type: "GET_ALL_NEW_GAME_SETINGS",
          uid: UID,
          settings: newNewGameSettings,
        });


        dispatch({
          type: "GET_ALL_GAME_SETINGS",
          uid: UID,
          settings: newGameSettings,
        });



        dispatch({ type: "SET_SOUND", uid: UID, data: newSoundOnSetting });

        resolve();
      })
    );
  };
};
/*
export function setNewDesignSetting(value, uid) {
  if (uid && setting) {
    return dispatch => new Promise(resolve => resolve(dispatch({ type: 'SET_NEW_DESIGN_SETING', value, uid })));
  }
  return () => new Promise(resolve => resolve());
} */

export function changeNotificationSettingsMobile(setting, multiple, deselect) {
  return dispatch => new Promise(resolve => resolve(dispatch({
    type: 'CHANGE_NOTIFICATION_SETINGS_MOBILE', setting, multiple, deselect,
  })));
}

export const getUserSetting = () => (dispatch) => {
  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;
  return new Promise(resolve => FirebaseRef.child(`userSettings/${UID}`)
    .on('value', (snapshot) => {
      dispatch({
        type: 'CHANGE_NOTIFICATION_SETINGS_MOBILE',
        resetOther: true,
        setting: snapshot.val() || {
          leaveRoom: true,
          lastRound: true,
          quitRound: true,
          ignorePlayer: true,
          quitAccount: true,
          purchaseGift: true,
          removeGift: true,
          showAfterRound: true,
          showAtRoomEnd: true,
        },
        multiple: true,
      });
      AsyncStorage.setItem('notificationsSettings', JSON.stringify(snapshot.val()));
      resolve();
    }));
};

export function toggleAllNotificationSettings(uid) {
  if (uid) {
    return dispatch => new Promise(resolve => resolve(dispatch({ type: 'TOGGLE_ALL_NOTIFICATION_SETTINGS', uid })));
  }
  return () => new Promise(resolve => resolve());
}

export function toggleRoomChat(uid) {
  if (uid) {
    return dispatch => new Promise(resolve => resolve(dispatch({ type: 'TOGGLE_ROOM_CHAT', uid })));
  }
  return () => new Promise(resolve => resolve());
}

export function toggleScoreTable(uid) {
  if (uid) {
    return dispatch => new Promise(resolve => resolve(dispatch({ type: 'TOGGLE_SCORE_TABLE', uid })));
  }
  return () => new Promise(resolve => resolve());
}

export function toggleMobileScoreTable(uid, mobileScoreTableOpen) {
  if (uid) {
    return dispatch => new Promise(resolve => resolve(dispatch({ type: 'TOGGLE_MOBILE_SCORE_TABLE', uid, mobileScoreTableOpen })));
  }
  return () => new Promise(resolve => resolve());
}
